module.exports = __webpack_public_path__ + "img/LU.bcf25fb7.svg";